import { render, staticRenderFns } from "./NuevaSolicitudPantalla.vue?vue&type=template&id=6c3f9c26&"
import script from "./NuevaSolicitudPantalla.vue?vue&type=script&lang=ts&"
export * from "./NuevaSolicitudPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6c3f9c26', component.options)
    } else {
      api.reload('6c3f9c26', component.options)
    }
    module.hot.accept("./NuevaSolicitudPantalla.vue?vue&type=template&id=6c3f9c26&", function () {
      api.rerender('6c3f9c26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/NuevaSolicitud/NuevaSolicitudPantalla.vue"
export default component.exports